// Landing
import React from "react";

// Component
import LandingSliderLaptop from "../LandingSliderLaptop";

// Image
import mainBg from "@images/landing/pattern.jpg";

const LandingSliderInfo = () => (
  <div
    className="py-5 bg-light"
    style={{ background: `url(${mainBg})`, backgroundSize: "cover" }}
  >
    <h2 className="px-2 px-sm-0 text-sm-center text-black">
      <b>Ситуация под контролем</b>
    </h2>
    <p className="px-2 px-sm-0 h5 mt-2 text-sm-center">
      Получайте свежие аналитические данные в рамках отдельной компании, региона
      или целой страны
    </p>
    <div className="mt-4">
      <LandingSliderLaptop />
    </div>
  </div>
);

export default LandingSliderInfo;
